import { render, staticRenderFns } from "./PremiumMaterialsOrderConfirmation.vue?vue&type=template&id=125a4039&"
import script from "./PremiumMaterialsOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./PremiumMaterialsOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports